import { useVuelidate } from "@vuelidate/core";


export const redevanceFormProps = () => ({
  produits: {
    type: Array,
    required: true
  },
  client: {
    type: Object,
    required: true
  }
})

export const redevanceFormEmits = () => ([
  "applyRedevance"
])

export const useRedevanceForm = (props, context) => {
  const model = ref({
    nom: "",
    prenom: "",
    civilite: "Mme",
    date_naissance: "",
    departement_naissance: "",
    ville_naissance: ""
  });

  const usage = ref(mapUsage());

  const usageOptions = ref([
    { value: 1, text: "À titre privé, dans une résidence principale" },
    { value: 2, text: "À titre privé, dans une résidence secondaire" },
    { value: 3, text: "Dans un débit de boisson (Licence II, III, IV)" },
    { value: 4, text: "Dans un autre lieu public" }
  ]);

  const v$ = useVuelidate();

  const applyRedevance = () => {
    if (!v$.$invalid) {
      const m = model.value;
      m.usage = usage.value.map(usage => {
        return { id: usage.id, usage_type: usage.usage_type };
      });
      context.emit("applyRedevance", m);
    } else {
      v$.$touch();
    }
  }
  const mapUsage = () => {
    return props.produits.map(produit => {
      return {
        id: produit.id,
        visuel: produit.visuel,
        designation: produit.designation,
        usage_type: null
      };
    });
  }
  const mounted = () => {
    model.value.nom = props.client.attributes.nom;
    model.value.prenom = props.client.attributes.prenom;
    model.value.civilite = props.client.attributes.civilite;
  }

  return {
    model,
    usage,
    usageOptions,
    v$,
    applyRedevance,
    mounted
  }
}